import React from "react";
import { MdAdd } from "react-icons/md";

const MyNftsHeader = ({ positionIdsQuantity, handleAddLiquidityClick }) => {
	return (
		<header className=" px-6 md:px-8 py-6 border-b border-lightGrayBlue dark:border-darkSlateBlue">
			<div className="flex justify-between md:items-center">
				<div className="flex gap-3 items-center mb-3">
					<h3 className="text-black dark:text-white font-bold text-2xl leading-9">
						My NFTs
					</h3>
					<span className="bg-lightBlue w-7 text-semiBlack dark:bg-darkButBg dark:text-semiWhite text-xs text-center leading-6 rounded-lg">
						{positionIdsQuantity}
					</span>
				</div>
				<button
					type="button"
					onClick={handleAddLiquidityClick}
					className="h-10 w-[138px] md:w-37.5 flex gap-2 
					items-center justify-center text-white text-sm 
					leading-[21px] font-semibold rounded-lg border 
					border-white bg-deepBlue shadow-swapButton transition-colors duration-300 bg-deepBlue hover:bg-vividBlueViolet active:bg-[#1E31FF]"
				>
					<MdAdd className="w-6 h-6" /> <span>Add liquidity</span>
				</button>
			</div>
		</header>
	);
};

export default MyNftsHeader;
